var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMediumLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#2F80ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.025 14.8851C16.025 17.3989 14.0046 19.4367 11.5126 19.4367C9.02049 19.4367 7 17.3984 7 14.8851C7 12.3717 9.02033 10.3333 11.5126 10.3333C14.0048 10.3333 16.025 12.3712 16.025 14.8851Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9735 14.885C20.9735 17.2512 19.9633 19.1702 18.7172 19.1702C17.4711 19.1702 16.4609 17.2512 16.4609 14.885C16.4609 12.5188 17.471 10.5999 18.7171 10.5999C19.9632 10.5999 20.9733 12.5182 20.9733 14.885",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.001 14.8852C23.001 17.0048 22.6458 18.7241 22.2074 18.7241C21.7691 18.7241 21.4141 17.0052 21.4141 14.8852C21.4141 12.7652 21.7693 11.0464 22.2074 11.0464C22.6456 11.0464 23.001 12.7651 23.001 14.8852Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediumLogo);
export default __webpack_public_path__ + "static/media/mediumLogo.1f62ad41f028733665496e42fd33e6dd.svg";
export { ForwardRef as ReactComponent };